import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X, Download } from "lucide-react";

// Full-screen viewer: whole image fitted to the screen, native pinch-to-zoom, download.
export function ImageViewer({ src, alt = "Image", filename = "brynai-image.png", onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", esc); document.body.style.overflow = prev; };
  }, [src, onClose]);
  if (!src) return null;
  return createPortal(
    <div className="fixed inset-0 z-[70] bg-black/95 flex flex-col rise" onClick={onClose} data-testid="image-viewer">
      <div className="flex justify-end gap-2 p-3 pt-[max(0.75rem,env(safe-area-inset-top))]" onClick={(e) => e.stopPropagation()}>
        <a href={src} download={filename} className="h-11 px-4 rounded-full bg-white/10 hover:bg-white/20 text-white text-sm inline-flex items-center gap-2" data-testid="image-viewer-download">
          <Download className="h-4 w-4" /> Download
        </a>
        <button onClick={onClose} className="h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" aria-label="Close" data-testid="image-viewer-close">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-auto flex items-center justify-center p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] [touch-action:pinch-zoom_pan-x_pan-y]">
        <img src={src} alt={alt} onClick={(e) => e.stopPropagation()} className="max-w-full max-h-full object-contain" data-testid="image-viewer-img" />
      </div>
    </div>,
    document.body,
  );
}
